/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CatalogDeleteCatalogResponse } from "./CatalogDeleteCatalogResponse";

export type CatalogDeleteCatalogResponseApiRespoonse = {
  data?: CatalogDeleteCatalogResponse;
  status?: CatalogDeleteCatalogResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace CatalogDeleteCatalogResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
